const ORGANIZATION_TYPES = {
    CUSTOMER: 'customer',
    RETAILER: 'retailer',
};

export default ORGANIZATION_TYPES ;